import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@mui/material";
import Interaction from "../../../models/interactions/Interaction";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import { navSliceActions } from "../../../store/slices/NavSlice";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import useHttp from "../../../hooks/useHttp";
import { useState } from "react";

import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

import MenuList from "@mui/material/MenuList";
import Interval from "../../../models/communications/Interval";
import InteractionNode from "../../../models/interactions/InteractionNode";
import InteractionNodeInterval from "../../../models/interactions/InteractionNodeInterval";
import { interactionTreeSliceActions } from "../../../store/slices/InteractionTreeSlice";
import { stateDeepCopy } from "../../../helpers/DataUpdateHelper";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
  },
  list: {
    marginTop: 20,
    padding: "0 60px",
    marginBottom: 40,
  },
  title: {
    fontSize: "2em",
    fontWeight: "bold",
    padding: "15px 0",
  },
  icon: {
    color: "#1976d2",
  },
});

interface InteractionIntervalsButtonProps {
  interaction: Interaction;
  interactionNode?: InteractionNode | null | undefined;
  standardButton?: boolean | null | undefined;
  textAlign?: string | undefined;
  insertFunction?: any;

}

const InteractionIntervalsButton = (props: InteractionIntervalsButtonProps) => {
  const interactionNodes = useStoreSelector(
    (state) => state.interactionTree.InteractionNodes,
  );

  const { sendRequest: fetchData } = useHttp();

  // dropdown controls
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useStoreDispatch();

  const classes = useStyles();

  const handleAddExistingInterval = (type: string) => {
    dispatch(
      navSliceActions.openModal({
        thisSet: props.interactionNode?.set_interaction_id,
        thisParent: props.interactionNode?.id,
        type: type,
      }),
    );
    handleClose();
  };

  let alignItems = "left";
  if (props.textAlign && typeof props.textAlign === "string") {
    alignItems = props.textAlign;
  }

  const interactionNodeArray : Array<InteractionNode> = []
  if(props.interactionNode){
    interactionNodeArray.push(props.interactionNode)
  }

  return (
    <div >
      { (
        <Tooltip title="Add new interval">
          <IconButton onClick={handleClick}>
            <CalendarMonthIcon />
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}
      {props.standardButton === true && (
        <Tooltip title="Add new interval2">
          <Button variant="contained" onClick={handleClick}>
            <CalendarMonthIcon />
            <AddIcon />
          </Button>
        </Tooltip>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuList style={{ color: "#1976d2" }}>
          <MenuItem
            onClick={() => {
              if(props.insertFunction){
                props.insertFunction(interactionNodeArray,null,"New Interval",0,0,null)
              }
            }}
          >
            <ListItemIcon>
              <MoreTimeIcon fontSize="small" className={classes.icon} />
            </ListItemIcon>
            <ListItemText>Add New Interval</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleAddExistingInterval("interval");
            }}
          >
            <ListItemIcon>
              <FolderOpenOutlinedIcon
                fontSize="small"
                className={classes.icon}
              />
            </ListItemIcon>
            <ListItemText>Add Existing Interval</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  );
};

export default InteractionIntervalsButton;

// "Perhaps you meant to call the function test.create_new_interaction_node_interval(communication_set_id, condition_id, interaction_node_id, interval_id, target)","message":
// "Could not find the function test.create_new_interaction_node_interval(communication_set_id, condition_id, interaction_node_id, target) in the schema cache"}
